import React from 'react'
import { useEffect, useState, useRef, createRef, useImperativeHandle, forwardRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryRemarks from "../components/EntryRemarks";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import GridPanelControl from "../components/GridPanelControl";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, NumConv, DeepCopy, isEnabled,
    getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, Round, DicVal, RandomKey
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, reports, applylinkfield, gridmaximize} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Spec = props => {
    const GridPanelStorageKey = "Spec_GridPanel";   //GridPanel最大化フラグ保存キー

    const panelsdef = [];
    const G_id = {
        BASE: "0", SPEC1: "10", SPEC2: "11", SPEC3: "12", SPEC4: "13", SPEC5: "14",
        SPEC6: "15", SPEC7: "16", SPEC8: "17", SPEC9: "18", SPEC10: "19",NB: "nb", IMAGE: "pic", FILE: "file"
    }

    const primarykeys = ["d_spec_no", "d_spec_row_key"];
    const formid = getformid("Spec", props.location.search);
    const controller = getcontroller("Spec", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefspec1 = useRef({ grid: undefined });
    const apiRefspec2 = useRef({ grid: undefined });
    const apiRefspec3 = useRef({ grid: undefined });
    const apiRefspec4 = useRef({ grid: undefined });
    const apiRefspec5 = useRef({ grid: undefined });
    const apiRefspec6 = useRef({ grid: undefined });
    const apiRefspec7 = useRef({ grid: undefined });
    const apiRefspec8 = useRef({ grid: undefined });
    const apiRefspec9 = useRef({ grid: undefined });
    const apiRefspec10 = useRef({ grid: undefined });
    const locationstate = useRef(null);    //遷移State

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const search = useLocation().search;
    const reportsRef = useRef(null);
    const GridPanelRef = useRef(null);      //最大化状態
    const prelayout = useRef(false);

    //データ
    const entrydataRef = useRef(null);    
    const spec1dataRef = useRef(null);
    const spec2dataRef = useRef(null);
    const spec3dataRef = useRef(null);
    const spec4dataRef = useRef(null);
    const spec5dataRef = useRef(null);
    const spec6dataRef = useRef(null);
    const spec7dataRef = useRef(null);
    const spec8dataRef = useRef(null);
    const spec9dataRef = useRef(null);
    const spec10dataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    //列情報
    const spec1colRef = useRef(null);
    const spec2colRef = useRef(null);
    const spec3colRef = useRef(null);
    const spec4colRef = useRef(null);
    const spec5colRef = useRef(null);
    const spec6colRef = useRef(null);
    const spec7colRef = useRef(null);
    const spec8colRef = useRef(null);
    const spec9colRef = useRef(null);
    const spec10colRef = useRef(null);
    const coldefRefs = [
        { id: G_id.SPEC1, ref: spec1colRef, dataref: spec1dataRef, api: apiRefspec1.current, table: "d_spec_row", elemid: "spec1Grid" },
        { id: G_id.SPEC2, ref: spec2colRef, dataref: spec2dataRef, api: apiRefspec2.current, table: "d_spec_row", elemid: "spec2Grid" },
        { id: G_id.SPEC3, ref: spec3colRef, dataref: spec3dataRef, api: apiRefspec3.current, table: "d_spec_row", elemid: "spec3Grid" },
        { id: G_id.SPEC4, ref: spec4colRef, dataref: spec4dataRef, api: apiRefspec4.current, table: "d_spec_row", elemid: "spec4Grid" },
        { id: G_id.SPEC5, ref: spec5colRef, dataref: spec5dataRef, api: apiRefspec5.current, table: "d_spec_row", elemid: "spec5Grid" },
        { id: G_id.SPEC6, ref: spec6colRef, dataref: spec6dataRef, api: apiRefspec6.current, table: "d_spec_row", elemid: "spec6Grid" },
        { id: G_id.SPEC7, ref: spec7colRef, dataref: spec7dataRef, api: apiRefspec7.current, table: "d_spec_row", elemid: "spec7Grid" },
        { id: G_id.SPEC8, ref: spec8colRef, dataref: spec8dataRef, api: apiRefspec8.current, table: "d_spec_row", elemid: "spec8Grid" },
        { id: G_id.SPEC9, ref: spec9colRef, dataref: spec9dataRef, api: apiRefspec9.current, table: "d_spec_row", elemid: "spec9Grid" },
        { id: G_id.SPEC10, ref: spec10colRef, dataref: spec10dataRef, api: apiRefspec10.current, table: "d_spec_row", elemid: "spec10Grid" }
        ];

    function statusKey(id) {
        return formid + "entry_" + id;
    }


    const actionurl = {
        "insert": "spec/Insert",
        "update": "spec/Update",
        "delete": "spec/Delete",
        "saveas": "spec/SaveAs",
        "storageadd": "spec/AddStorage",
        "storagerowdel": "spec/StorageRowdel",
        "upload": "spec/Upload",
        "imageadd":"spec/AddImage",
        "masonry": "spec/Masonry",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "formupload2", icon: "upload_file", label: "画像/資料マスタのファイルを追加", title: "画像/資料マスタのファイルを追加します" },
        { status: "ENTRY FORM", menuid: "sep1" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep3" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "upload2", icon: "upload_file", label: "画像/資料マスタのファイルを追加", title: "画像/資料マスタのファイルを追加します" },
        { status: "VIEW", menuid: "sep4" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }

    function onDragEnter(e){
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;

                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    //列情報初期化
                    let gridmaxinit = {};
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                        gridmaxinit[ coldefRefs[i].id] = false;
                    }
                    //パネル最大化Flag
                    var gridmax = Getstorage(corpkey, account, GridPanelStorageKey);    //保存データ
                    if( isEmpty(gridmax)){
                        gridmax = gridmaxinit;
                    }
                    GridPanelRef.current = gridmax
                    dispatch(gridmaximize(gridmax));
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_spec_no"] = "";
            entrydataRef.current["d_spec_createac"] = "";
            entrydataRef.current["d_spec_createdate"] = "";
            entrydataRef.current["d_spec_updateac"] = "";
            entrydataRef.current["d_spec_update"] = "";
            rerender();
       }
    }, [formstatus]);



    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform(true, locationstate.current.acceptno);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, id) {
        switch (id) {
            case G_id.SPEC1:
                apiRefspec1.current.grid = param.api;
                break;
            case G_id.SPEC2:
                apiRefspec2.current.grid = param.api;
                break;
            case G_id.SPEC3:
                apiRefspec3.current.grid = param.api;
                break;
            case G_id.SPEC4:
                apiRefspec4.current.grid = param.api;
                break;
            case G_id.SPEC5:
                apiRefspec5.current.grid = param.api;
                break;
            case G_id.SPEC6:
                apiRefspec6.current.grid = param.api;
                break;
            case G_id.SPEC7:
                apiRefspec7.current.grid = param.api;
                break;
            case G_id.SPEC8:
                apiRefspec8.current.grid = param.api;
                break;
            case G_id.SPEC9:
                apiRefspec9.current.grid = param.api;
                break;
            case G_id.SPEC10:
                apiRefspec10.current.grid = param.api;
                break;
            default:
                break;
        }

        if (!isEmpty(locationstate.current)) {
            //描画終了を待つ
            let call = true;
            for (let i = 0; i < coldefRefs.length; i++) {
                if (EmptyPanel(coldefRefs[i].id)) continue;
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function onGridReady(param, id) {
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('spec/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_spec_memo" in row) data.data.d_spec_memo = row.d_spec_memo;
                                if ("d_spec_sticky" in row) data.data.d_spec_sticky = row.d_spec_sticky;
                                if ("d_spec_mytags" in row) data.data.d_spec_mytags = row.d_spec_mytags;
                            }
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                       //行データ
                        if (data.spec1.length !== 0) spec1dataRef.current = data.spec1;
                        if (data.spec2.length !== 0) spec2dataRef.current = data.spec2;
                        if (data.spec3.length !== 0) spec3dataRef.current = data.spec3;
                        if (data.spec4.length !== 0) spec4dataRef.current = data.spec4;
                        if (data.spec5.length !== 0) spec5dataRef.current = data.spec5;
                        if (data.spec6.length !== 0) spec6dataRef.current = data.spec6;
                        if (data.spec7.length !== 0) spec7dataRef.current = data.spec7;
                        if (data.spec8.length !== 0) spec8dataRef.current = data.spec8;
                        if (data.spec9.length !== 0) spec9dataRef.current = data.spec9;
                        if (data.spec10.length !== 0) spec10dataRef.current = data.spec10;

                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function showdata(data) {
        fnc.current.margeMaster(data.master);
        entrydataRef.current = data.data;

        //行データ
        if (data.spec1.length !== 0) spec1dataRef.current = data.spec1;
        if (data.spec2.length !== 0) spec2dataRef.current = data.spec2;
        if (data.spec3.length !== 0) spec3dataRef.current = data.spec3;
        if (data.spec4.length !== 0) spec4dataRef.current = data.spec4;
        if (data.spec5.length !== 0) spec5dataRef.current = data.spec5;
        if (data.spec6.length !== 0) spec6dataRef.current = data.spec6;
        if (data.spec7.length !== 0) spec7dataRef.current = data.spec7;
        if (data.spec8.length !== 0) spec8dataRef.current = data.spec8;
        if (data.spec9.length !== 0) spec9dataRef.current = data.spec9;
        if (data.spec10.length !== 0) spec10dataRef.current = data.spec10;

        imageRef.current = data.images;
        fileRef.current = data.files;
        dispatch(setimagelist(data.images));
    }

    function existPanel(id) {
        let pnl = panel.find(e => e.id === id);
        return pnl !== undefined;
    }
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (isEmpty(AGRef.current)) return;
        for (let i = 0; i < coldefRefs.length; i++) {
            if (panel === undefined || panel === coldefRefs[i].id) {
                let grid = coldefRefs[i].api.grid;
                coldefRefs[i].dataref.current = AGRef.current.GetDatasource(grid);
            }
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.SPEC1) panelid = 'spec1Grid';
        if (id === G_id.SPEC2) panelid = 'spec2Grid';
        if (id === G_id.SPEC3) panelid = 'spec3Grid';
        if (id === G_id.SPEC4) panelid = 'spec4Grid';
        if (id === G_id.SPEC5) panelid = 'spec5Grid';
        if (id === G_id.SPEC6) panelid = 'spec6Grid';
        if (id === G_id.SPEC7) panelid = 'spec7Grid';
        if (id === G_id.SPEC8) panelid = 'spec8Grid';
        if (id === G_id.SPEC9) panelid = 'spec9Grid';
        if (id === G_id.SPEC10) panelid = 'spec10Grid';
        if (id === G_id.FILE || id === G_id.FILE2) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        let elem = document.getElementById(panelid);
        if (elem === undefined) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuQueryAction(action, param) {
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSavestorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            if (finallycallback.table === "d_spec" || finallycallback.type === "100") {
                let type = "100";
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    type = col.type;
                    let key = finallycallback.field + "_" + type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let target = coldefRefs.find(e => e.table === finallycallback.table);
            if (isEmpty(target)) return;
            Jump(target.id);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, target.api.grid);
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('spec/GetDataTree', { "controller": controller, "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Save(finallycallback) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "spec1": EmptyPanel(G_id.SPEC1) ? null : spec1dataRef.current,
            "spec2": EmptyPanel(G_id.SPEC2) ? null : spec2dataRef.current,
            "spec3": EmptyPanel(G_id.SPEC3) ? null : spec3dataRef.current,
            "spec4": EmptyPanel(G_id.SPEC4) ? null : spec4dataRef.current,
            "spec5": EmptyPanel(G_id.SPEC5) ? null : spec5dataRef.current,
            "spec6": EmptyPanel(G_id.SPEC6) ? null : spec6dataRef.current,
            "spec7": EmptyPanel(G_id.SPEC7) ? null : spec7dataRef.current,
            "spec8": EmptyPanel(G_id.SPEC8) ? null : spec8dataRef.current,
            "spec9": EmptyPanel(G_id.SPEC9) ? null : spec9dataRef.current,
            "spec10": EmptyPanel(G_id.SPEC10) ? null : spec10dataRef.current,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "spec/UpdateEntry" : "spec/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["d_spec_no"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("spec", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("spec/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform, acceptno) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        spec1dataRef.current = null;
        spec2dataRef.current = null;
        spec3dataRef.current = null;
        spec4dataRef.current = null;
        spec5dataRef.current = null;
        spec6dataRef.current = null;
        spec7dataRef.current = null;
        spec8dataRef.current = null;
        spec9dataRef.current = null;
        spec10dataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;

        scrollRef.current = null;
        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        entrydataRef.current["d_spec_prodno"] = acceptno;
                        rerender();
                        if (!isEmpty(acceptno)) {
                            dispatch(applylinkfield("d_spec_prodno"));
                        }
                    },
                }, true
            )
        }

    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSavestorage() {
        //列情報保存
        for (let i = 0; i < coldefRefs.length; i++) {
            AGRef.current.SaveColState(statusKey(coldefRefs[i].id), EmptyPanel(coldefRefs[i].id) ? null : coldefRefs[i].column);
        }
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type:fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.SPEC1:
                    cols = AGRef.current.GetshownColDef(apiRefspec1.current.grid);
                    break;
                case G_id.SPEC2:
                    cols = AGRef.current.GetshownColDef(apiRefspec2.current.grid);
                    break;
                case G_id.SPEC3:
                    cols = AGRef.current.GetshownColDef(apiRefspec3.current.grid);
                    break;
                case G_id.SPEC4:
                    cols = AGRef.current.GetshownColDef(apiRefspec4.current.grid);
                    break;
                case G_id.SPEC5:
                    cols = AGRef.current.GetshownColDef(apiRefspec5.current.grid);
                    break;
                case G_id.SPEC6:
                    cols = AGRef.current.GetshownColDef(apiRefspec6.current.grid);
                    break;
                case G_id.SPEC7:
                    cols = AGRef.current.GetshownColDef(apiRefspec7.current.grid);
                    break;
                case G_id.SPEC8:
                    cols = AGRef.current.GetshownColDef(apiRefspec8.current.grid);
                    break;
                case G_id.SPEC9:
                    cols = AGRef.current.GetshownColDef(apiRefspec9.current.grid);
                    break;
                case G_id.SPEC10:
                    cols = AGRef.current.GetshownColDef(apiRefspec10.current.grid);
                    break;
                default:
                    continue;
            }
            if (panel[p].id !== G_id.BASE) {
                for (let i = 0; i < cols.length; i++) {
                    let col = DeepCopy(cols[i]);
                    col.type = tabletype(panel[p].id);
                    coldef.push(col);
                }
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //列幅、表示状態復元
    function RestoreColState(columns) {
        for (let i = 0; i < coldefRefs.length; i++) {
            var type = tabletype(coldefRefs[i].id);
            columns.filter(e => e.type === type).forEach((item) => {
                var result = coldefRefs[i].ref.current.find(e => e.colId === item.columnid);
                result.width = item.width;
                result.hide = !item.hidden === '0';
            });
        }
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    RestoreColState(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }


    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
   }

    //Grid Data Change
    function ChangeRowValue(params, id) {
        storeRowData(id);
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }


    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.SPEC1 || props.panel.id === G_id.SPEC2 || props.panel.id === G_id.SPEC3 || props.panel.id === G_id.SPEC4 || props.panel.id === G_id.SPEC5 ||
            props.panel.id === G_id.SPEC6 || props.panel.id === G_id.SPEC7 || props.panel.id === G_id.SPEC8 || props.panel.id === G_id.SPEC9 || props.panel.id === G_id.SPEC10) {
            let ref = coldefRefs.find(e => e.id === props.panel.id)
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid={ref.elemid}
                    entrydataRef={entrydataRef}
                    dataRef={ref.dataref}
                    columnRef={ref.ref}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(props.panel.id)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(props.panel.id)}
                    ValueChanged={(e) => ChangeRowValue(e, props.panel.id)}
                    RowValueChanged={() => storeRowData(props.panel.id)}
                    RemoveRow={() => storeRowData(props.panel.id)}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            //v1.4
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            if (id === G_id.NB) return isEmpty(columninfo.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.BASE && p.type !== '100') return true;

        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function maximizeChanged(id, max) {
        const newvalue = JSON.parse(JSON.stringify(GridPanelRef.current));
        newvalue[id] = max;
        GridPanelRef.current = newvalue;
        //ストレージに保存
        Savestorage(corpkey, account, GridPanelStorageKey, GridPanelRef.current);
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom:'300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {NumConv(p.id) === 0?null:
                                       <div style={{ position: 'absolute', right: 40, top: -3 }}>
                                           <GridPanelControl id={p.id} fnc={fnc} gridmaximize={GridPanelRef} ValueChanged={maximizeChanged}/>
                                       </div>
                                   }
                               </div>
                               <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_spec'}
                primarykey={primarykeys}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload' && e.menuid !== 'formupload2'):navmenu}
                masonry={true}
                lockcell={ListlockCell}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo}  entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

